export default __webpack_public_path__ + "static/media/quote.c831170d.png";